import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { ModalModule } from '@shared/components/modal/modal.module';
import { FileErrorDirective } from '@shared/components/most-used/directives/file.error.directive';
import { ResetControlDirective } from '@shared/components/most-used/directives/reset-control.directive';
import { TypedTemplateDirective } from '@shared/components/most-used/directives/typed-template.directive';
// eslint-disable-next-line max-len
import { ControlErrorContainerDirective } from '@shared/components/most-used/form-error/control-error-container.directive';
import { ControlBorderDirective } from '@shared/components/most-used/form-controls-errors/control-border.directive';
import { ControlWrapperDirective } from '@shared/components/most-used/form-controls-errors/control-wrapper.directive';
import { FocusManagerDirective } from '@shared/components/most-used/form-controls-errors/focus-manager.directive';
// eslint-disable-next-line max-len
import { FormControlErrorsDirective } from '@shared/components/most-used/form-controls-errors/form-control-error.directive';
import { TMPFormErrorDirective } from '@shared/components/most-used/form-error/tmp-form-error.directive';
import { SpinnerComponent } from '@shared/components/most-used/spinner/spinner.component';
import { SharedPipesModule } from '@shared/pipes/shared-pipes/shared-pipes.module';
import { FormErrorDirective } from './form-error/form-error.directive';
import { FormEventsDirective } from './form-error/form-events.directive';
import { TopbarComponent } from './topbar/topbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FilterComponent } from './filter/filter.component';
import { MatMenuModule } from '@angular/material/menu';
import { LangRedirectorComponent } from './lang-redirector/lang-redirector.component';
import { CardComponent } from './card/card.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FormErrorComponent } from './form-error/form-error-component/form-error.component';
import { CheckImageModule } from '@shared/directives/check-image/check-image.module.module';
// eslint-disable-next-line max-len
import { BorderErrorContainerDirective } from '@shared/components/most-used/form-error/border-error-container.directive';
import { ViewEditSwitchComponent } from './view-edit-switch/view-edit-switch.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { ClickShareWrapperComponent } from './click-share-wrapper/click-share-wrapper.component';
// eslint-disable-next-line max-len
import { DatepickerCustomizationsModule } from '@shared/components/datepicker-customizations/datepicker-customizations.module';
import { FormHasErrorsComponent } from './form-has-errors/form-has-errors.component';
import { ResetControlButtonComponent } from './reset-control-button/reset-control-button.component';

const COMPONENTS = [
  CardComponent,
  TopbarComponent,
  FilterComponent,
  SidebarComponent,
  FilterComponent,
  LangRedirectorComponent,
  FormErrorDirective,
  FormControlErrorsDirective,
  FocusManagerDirective,
  ControlBorderDirective,
  ControlWrapperDirective,
  FormErrorComponent,
  ControlErrorContainerDirective,
  BorderErrorContainerDirective,
  FormErrorComponent,
  FormEventsDirective,
  LangRedirectorComponent,
  SpinnerComponent,
  FileErrorDirective,
  ResetControlDirective,
  TypedTemplateDirective,
  TMPFormErrorDirective
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ViewEditSwitchComponent,
    PaginatorComponent,
    DateRangeComponent,
    ClickShareWrapperComponent,
    FormHasErrorsComponent,
    ResetControlButtonComponent,
  ],
  exports: [
    ...COMPONENTS,
    ViewEditSwitchComponent,
    PaginatorComponent,
    DateRangeComponent,
    ClickShareWrapperComponent,
    FormHasErrorsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatMenuModule,
    MatTabsModule,
    MatButtonModule,
    MatDatepickerModule,
    CheckImageModule,
    MatPaginatorModule,
    MatInputModule,
    ReactiveFormsModule,
    DatepickerCustomizationsModule,
    ModalModule,
    SharedPipesModule,
    MatSelectModule,
    FormsModule,
  ],
})
export class MostUsedModule {}
